import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const ProducerDetailsConfig = { auth: [...authRoles.admin, ...authRoles.producer], routes: [{ path: '/producer-management/:id?', component: FuseLoadable({ loader: () => import('./producer-details/ProducerDetails') }) }] };

export default ProducerDetailsConfig;
